(() => {
  if (window.solaveSeasonalInstalled) return;
  window.solaveSeasonalInstalled = true;
  const root = document.documentElement;
  const query = new URLSearchParams(location.search);
  const seasons = ["halloween", "christmas", "new-year", "valentines", "easter"];
  const requested = query.get("sv-season-preview");
  const forcedSeason = seasons.includes(requested) || requested === "none" ? requested : null;
  const requestedDate = query.get("sv-season-date");
  const dateValue = Date.parse(requestedDate + "T12:00:00Z");
  const testDate = /^\d{4}-\d{2}-\d{2}$/.test(requestedDate || "") && Number.isFinite(dateValue) && new Date(dateValue).toISOString().slice(0, 10) === requestedDate ? requestedDate : null;
  const formatter = new Intl.DateTimeFormat("en-GB", {timeZone: "Europe/Prague", year: "numeric", month: "2-digit", day: "2-digit"});
  const dateParts = () => {
    if (testDate) {
      const [year, month, day] = testDate.split("-").map(Number);
      return {year, month, day};
    }
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
    return {year: Number(parts.year), month: Number(parts.month), day: Number(parts.day)};
  };
  const easterSunday = year => {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    return Date.UTC(year, Math.floor((h + l - 7 * m + 114) / 31) - 1, (h + l - 7 * m + 114) % 31 + 1);
  };
  const currentSeason = () => {
    if (forcedSeason) return forcedSeason === "none" ? null : forcedSeason;
    const {year, month, day} = dateParts();
    if ((month === 10 && day >= 10) || (month === 11 && day <= 1)) return "halloween";
    if (month === 12 && day <= 26) return "christmas";
    if ((month === 12 && day >= 27) || (month === 1 && day <= 3)) return "new-year";
    if (month === 2 && day >= 7 && day <= 15) return "valentines";
    const offset = (Date.UTC(year, month - 1, day) - easterSunday(year)) / 86400000;
    return offset >= -7 && offset <= 1 ? "easter" : null;
  };
  let labels = {};
  try { labels = JSON.parse(document.getElementById("solave-seasonal-settings")?.textContent || "{}"); } catch {}
  const motion = matchMedia("(prefers-reduced-motion: reduce)");
  const compact = matchMedia("(max-width: 749px)");
  let paused = false;
  try { paused = localStorage.getItem("solave-season-effects-paused") === "1"; } catch {}
  let activeSeason;
  const svg = (content, viewBox = "0 0 48 48") =>
    '<svg class="sv-season-icon" viewBox="' + viewBox + '" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + content + '</svg>';
  let drawingSequence = 0;
  const lineDrawing = (url, width, height, color, className) => {
    const id = "sv-line-art-" + drawingSequence++;
    const rgb = color.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16) / 255);
    const matrix = "0 0 0 0 " + rgb[0] + " 0 0 0 0 " + rgb[1] + " 0 0 0 0 " + rgb[2] + " -0.299 -0.587 -0.114 1 0";
    return '<svg class="sv-season-icon sv-season-drawing ' + className + '" viewBox="0 0 ' + width + ' ' + height + '" aria-hidden="true" focusable="false"><defs><filter id="' + id + '" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="' + matrix + '"/></filter></defs><image href="' + url + '" x="0" y="0" width="' + width + '" height="' + height + '" filter="url(#' + id + ')"/></svg>';
  };
  const spiderDrawing = "https://cdn.shopify.com/s/files/1/1063/7256/3292/files/solave-halloween-spider.png?v=1792192944";
  const ghostDrawing = "https://cdn.shopify.com/s/files/1/1063/7256/3292/files/solave-halloween-ghost.png?v=1792192938";

  const seasonalIcons = {
    halloween: {
      mark: svg('<path d="M24 12c-2.5-3-5-3-7-1-5-1-9 4-9 11 0 9 6 15 16 15s16-6 16-15c0-7-4-12-9-11-2-2-4.5-2-7 1Z"/><path d="M22 12c0-4 1-7 4-9 2 3 2 6 0 9M16 15c-2 5-2 14 0 19M24 14v22M32 15c2 5 2 14 0 19"/><path d="M13 25h5m12 0h5m-13 8 2 1 2-1"/>'),
      card: lineDrawing(spiderDrawing, 1000, 813, "#786550", "sv-halloween-card-spider"),
      hero: lineDrawing(ghostDrawing, 600, 800, "#786550", "sv-halloween-hero-ghost"),
      particles: [
        lineDrawing(spiderDrawing, 1000, 813, "#786550", "sv-halloween-particle-spider"),
        lineDrawing(ghostDrawing, 600, 800, "#786550", "sv-halloween-particle-ghost")
      ],
      introLabel: 'HALLOWEEN / AFTER DARK',
      introArt: '<span class="sv-entry-halloween-drawing">' + lineDrawing(spiderDrawing, 1000, 813, "#ded0b5", "sv-entry-halloween-spider") + lineDrawing(ghostDrawing, 600, 800, "#ded0b5", "sv-entry-halloween-ghost") + '</span>'
    }
  };

  const drawings = {
    flake: '<g stroke="#e2eee7" stroke-width="2"><path d="M32 5v54M9 18l46 28M55 18 9 46M24 10l8 6 8-6M24 54l8-6 8 6M10 26l8-8-2-9M54 38l-8 8 2 9M54 26l-8-8 2-9M10 38l8 8-2 9"/></g>',
    tree: '<path fill="#325a46" stroke="#243f34" d="m32 5-17 20h9L10 41h15v14h14V41h15L40 25h9L32 5Z"/><path stroke="#dfbb70" d="M20 28c7 5 17 5 24 0M16 40c10 6 22 6 32 0"/><path fill="#dfbb70" stroke="#bc9456" d="m32 1 2.1 5.1 5.5.5-4.2 3.6 1.3 5.3L32 12.7l-4.7 2.8 1.3-5.3-4.2-3.6 5.5-.5L32 1Z"/><path stroke="#a37c54" stroke-width="5" d="M32 51v10"/><circle cx="26" cy="23" r="2" fill="#eac9a4" stroke="none"/><circle cx="38" cy="34" r="2" fill="#ce7770" stroke="none"/>',
    gift: '<path fill="#f0ddbd" stroke="#8f7354" d="M11 27h42v31H11z"/><path fill="#e8c99c" stroke="#8f7354" d="M7 20h50v12H7z"/><path stroke="#a85a55" stroke-width="5" d="M32 21v37"/><path fill="#c17b73" stroke="#92564e" d="M31 20C9 22 11 3 21 7c7 2 10 13 10 13Zm2 0C55 22 53 3 43 7c-7 2-10 13-10 13Z"/>',
    bauble: '<path stroke="#b79558" d="M32 1v12"/><rect x="26" y="12" width="12" height="6" rx="2" fill="#e1c17f" stroke="#9c7e47"/><circle cx="32" cy="37" r="21" fill="#b56b64" stroke="#864f4b"/><path stroke="#efd5ad" d="M12 34c11 8 29 8 40 0M14 43c10 5 26 5 36 0"/><path stroke="#fff1d7" stroke-width="3" d="M22 24c-4 2-6 6-6 10"/>',
    heart: '<path fill="#d8899a" stroke="#a4556a" d="M32 57 9 35C-4 22 4 6 17 6c7 0 12 5 15 11C35 11 40 6 47 6c13 0 21 16 8 29L32 57Z"/><path stroke="#f9dce1" stroke-width="3" d="M11 24c-1-7 4-12 10-10"/>',
    bow: '<path fill="#d79aa8" stroke="#a45c73" d="M28 25C3 7 3 40 28 34l-8 23 12-8 12 8-8-23C61 40 61 7 36 25Z"/><rect x="26" y="23" width="12" height="14" rx="4" fill="#b56c82" stroke="#9f566e"/>',
    star: '<path fill="#e6ca85" stroke="#aa8a46" d="m32 4 7 19 21 1-16 14 5 21-17-12-17 12 5-21L4 24l21-1 7-19Z"/><path stroke="#fff4ce" d="m31 14-4 14-13 1"/>',
    firework: '<g stroke="#d8b96e" stroke-width="1.8"><path d="M32 3v17M32 44v17M3 32h17M44 32h17M11 11l12 12M41 41l12 12M53 11 41 23M23 41 11 53"/><path stroke="#f3dfac" d="m20 4 7 17M37 43l7 17M4 20l17 7M43 37l17 7M44 4l-7 17M27 43l-7 17M60 20l-17 7M21 37 4 44"/></g><g fill="#fff2cd" stroke="none"><circle cx="32" cy="32" r="2"/><circle cx="7" cy="7" r="1.5"/><circle cx="57" cy="57" r="1.5"/><circle cx="57" cy="7" r="1.5"/><circle cx="7" cy="57" r="1.5"/></g>',
    bunny: '<path fill="#f7efe2" stroke="#847661" d="M22 30C8 6 17-5 25 8c4 7 6 16 5 22m12 0C56 6 47-5 39 8c-4 7-6 16-5 22"/><path stroke="#dfb5ad" stroke-width="3" d="m21 11 6 15m16-15-6 15"/><path fill="#f7efe2" stroke="#847661" d="M13 43c0-13 8-21 19-21s19 8 19 21c0 13-7 19-19 19s-19-6-19-19Z"/><g fill="#675e53" stroke="none"><circle cx="24" cy="40" r="2"/><circle cx="40" cy="40" r="2"/></g><path fill="#d39a98" stroke="none" d="m29 46 3 3 3-3Z"/><path stroke="#847661" d="M32 49v3m-6-1q6 6 12 0"/><ellipse cx="20" cy="47" rx="4" ry="2" fill="#edc7bd" stroke="none"/><ellipse cx="44" cy="47" rx="4" ry="2" fill="#edc7bd" stroke="none"/>',
    egg: '<path fill="#b9cab4" stroke="#7c947a" d="M32 4c10 0 22 20 22 35S45 61 32 61 10 54 10 39 22 4 32 4Z"/><path stroke="#f7efe0" stroke-width="3" d="m14 27 6 5 6-5 6 5 6-5 6 5 6-5M12 43h40M20 53l4-4 4 4 4-4 4 4 4-4 4 4"/><circle cx="32" cy="17" r="3" fill="#f6ebce" stroke="none"/>',
    eggRose: '<path fill="#e2b3b3" stroke="#af818c" d="M32 4c10 0 22 20 22 35S45 61 32 61 10 54 10 39 22 4 32 4Z"/><path stroke="#fff0df" stroke-width="3" d="M14 28h36M12 45h40"/><g fill="#fff0df" stroke="none"><circle cx="23" cy="37" r="2"/><circle cx="40" cy="37" r="2"/><circle cx="31" cy="19" r="2"/><circle cx="31" cy="54" r="2"/></g>',
    whip: '<g stroke="#9c8458" stroke-width="2.5"><path d="m30 61 4-45M34 61l-4-45M28 56l9-7-8-7 9-7-8-7 7-7"/><path d="m33 17-3-12m3 12 4-13m-4 13 1-15"/></g><path fill="#d7a7b2" stroke="#ad7c91" d="m32 16-14-5 1 8 12 3-7 17 8-5 5-14Z"/><path fill="#daca98" stroke="#a99a68" d="m34 16 13-8-1 9-10 5 8 14-8-3-5-13Z"/>',
    flower: '<g fill="#edc4c3" stroke="#bd999a"><ellipse cx="32" cy="18" rx="9" ry="13"/><ellipse cx="32" cy="46" rx="9" ry="13"/><ellipse cx="18" cy="32" rx="13" ry="9"/><ellipse cx="46" cy="32" rx="13" ry="9"/></g><circle cx="32" cy="32" r="9" fill="#e7d293" stroke="#b9a76f"/>'
  };
  const icon = name => svg(drawings[name], "0 0 64 64");
  const introGroup = (content) => svg(content, "0 0 260 260");
  Object.assign(seasonalIcons, {
    christmas: {mark: icon("flake"), card: icon("gift"), hero: icon("tree"), introLabel: "WINTER / SOLAVE", introArt: introGroup('<g transform="translate(60 68) scale(2.2)">' + drawings.tree + '</g><g transform="translate(175 20) scale(.7)">' + drawings.flake + '</g><g transform="translate(15 170) scale(.8)">' + drawings.bauble + '</g>')},
    "new-year": {mark: icon("star"), card: icon("star"), hero: icon("firework"), introLabel: "NEW YEAR / SOLAVE", introArt: introGroup('<g transform="translate(55 30) scale(2.3)">' + drawings.firework + '</g><g transform="translate(160 170) scale(.9)">' + drawings.star + '</g><g transform="translate(20 190) scale(.5)">' + drawings.star + '</g>')},
    valentines: {mark: icon("heart"), card: icon("bow"), hero: icon("heart"), introLabel: "LOVE / SOLAVE", introArt: introGroup('<g transform="translate(80 25) rotate(12 32 32) scale(1.8)">' + drawings.heart + '</g><g transform="translate(20 135) rotate(-14 32 32) scale(1.1)">' + drawings.heart + '</g><g transform="translate(162 174) scale(.8)">' + drawings.bow + '</g>')},
    easter: {mark: icon("bunny"), card: icon("egg"), hero: icon("bunny"), introLabel: "SPRING / SOLAVE", introArt: introGroup('<g transform="translate(75 40) scale(2)">' + drawings.bunny + '</g><g transform="translate(20 154) rotate(-12 32 32) scale(1.1)">' + drawings.egg + '</g><g transform="translate(170 156) rotate(12 32 32) scale(1)">' + drawings.eggRose + '</g>')}
  });

  const owned = (tag, className, content = "") => {
    const node = document.createElement(tag);
    node.className = className;
    node.dataset.solaveOwnedDecoration = "";
    node.setAttribute("aria-hidden", "true");
    node.innerHTML = content;
    return node;
  };
  const positions = [2, 7, 94, 98, 4, 96, 1, 99];
  const particle = (className, index, content = "", wholeWidth = false) => {
    const node = owned("i", className, content);
    node.style.setProperty("--sv-f-x", (wholeWidth ? (index * 37 + 7) % 100 : positions[index % positions.length]) + "%");
    node.style.setProperty("--sv-f-delay", -((index * 1.73) % 15) + "s");
    node.style.setProperty("--sv-f-duration", (motion.matches ? 30 : 16) + index % 7 + "s");
    node.style.setProperty("--sv-f-size", (className.includes("snow") ? 3 + index % 4 : 17 + index % 3 * 5) + "px");
    node.style.setProperty("--sv-f-drift", (index % 2 ? -1 : 1) * (14 + index % 4 * 8) + "px");
    return node;
  };
  const syncPaused = () => {
    root.dataset.solaveEffects = paused ? "paused" : "playing";
    const button = document.querySelector(".sv-festive-toggle");
    if (button) {
      const text = (paused ? labels.resume : labels.pause) || (paused ? "Play seasonal effects" : "Pause seasonal effects");
      button.setAttribute("aria-label", text);
      button.setAttribute("title", text);
      button.setAttribute("aria-pressed", String(paused));
      button.innerHTML = svg(paused ? '<path d="m18 11 20 13-20 13V11Z"/>' : '<path d="M18 12v24m12-24v24"/>');
    }
  };
  const mountHalloween = () => {
    const overlay = owned("div", "sv-season-scene sv-season-scene--halloween");
    overlay.dataset.solaveSeasonScene = "halloween";
    for (let index = 0; index < 6; index++) {
      const node = owned("span", "sv-season-particle", seasonalIcons.halloween.particles[index % 2]);
      node.style.setProperty("--sv-x", positions[index] + "%");
      node.style.setProperty("--sv-delay", -(index * 2.3) + "s");
      node.style.setProperty("--sv-duration", (22 + index % 4) + "s");
      overlay.appendChild(node);
    }
    for (const side of ["left", "right"]) overlay.appendChild(owned("i", "sv-season-web sv-season-web--" + side));
    document.body.appendChild(overlay);
  };
  const mountScene = season => {
    if (season === "halloween") return mountHalloween();
    const scene = owned("div", "sv-festive-scene sv-festive-scene--" + season);
    scene.dataset.solaveSeasonScene = season;
    const small = compact.matches;
    if (season === "christmas") {
      const count = motion.matches ? 10 : small ? 20 : 34;
      for (let i = 0; i < count; i++) {
        const crystal = i % 7 === 0;
        const node = particle("sv-festive-snow" + (crystal ? " sv-festive-snow--crystal" : ""), i, crystal ? icon("flake") : "", true);
        if (crystal) node.style.setProperty("--sv-f-size", (10 + i % 3 * 2) + "px");
        scene.appendChild(node);
      }
    }
    if (season === "valentines") {
      for (let i = 0; i < (small || motion.matches ? 4 : 6); i++) scene.appendChild(particle("sv-festive-heart", i, icon("heart")));
    }
    if (season === "new-year") {
      for (let i = 0; i < (small || motion.matches ? 2 : 4); i++) {
        const burst = particle("sv-festive-firework", i, icon("firework"));
        burst.style.setProperty("--sv-f-x", 94 + "%");
        burst.style.setProperty("--sv-f-y", (22 + i * 18) + "%");
        burst.style.setProperty("--sv-f-size", (motion.matches ? 76 : small ? 90 : 136) + "px");
        burst.style.setProperty("--sv-f-duration", (motion.matches ? 12 : 7) + i + "s");
        scene.appendChild(burst);
      }
      for (let i = 0; i < (small || motion.matches ? 8 : 12); i++) scene.appendChild(particle("sv-festive-confetti", i));
    }
    if (season === "easter") {
      for (let i = 0; i < (small || motion.matches ? 4 : 6); i++) scene.appendChild(particle("sv-festive-petal", i, i % 3 === 0 ? icon("flower") : ""));
    }
    document.body.appendChild(scene);
  };
  const heroDecorations = season => {
    if (season === "christmas") {
      const lights = [39, 42, 36, 20, 7, 3, 7, 20, 32, 36, 29].map((y, i) => '<circle class="sv-festive-light" cx="' + (i * 100 + 100) + '" cy="' + y + '" r="3.5" style="animation-delay:-' + (i % 4) + 's"/>').join("");
      return '<span class="sv-festive-garland">' + svg('<path d="M-30 8Q180 72 400 20T800 20t430-12" stroke="#4a7159" stroke-width="4"/>' + lights, "0 0 1200 90") + '</span><span class="sv-festive-hanging">' + icon("bauble") + '</span><span class="sv-festive-tree">' + icon("tree") + '</span>';
    }
    if (season === "new-year") return '<span class="sv-festive-hero-burst">' + icon("firework") + '</span><span class="sv-festive-hero-star">' + icon("star") + '</span>';
    if (season === "valentines") return '<span class="sv-festive-love sv-festive-love--one">' + icon("heart") + '</span><span class="sv-festive-love sv-festive-love--two">' + icon("heart") + '</span><span class="sv-festive-love-bow">' + icon("bow") + '</span>';
    return '<span class="sv-festive-bunny">' + icon("bunny") + '</span><span class="sv-festive-egg sv-festive-egg--sage">' + icon("egg") + '</span><span class="sv-festive-egg sv-festive-egg--rose">' + icon("eggRose") + '</span><span class="sv-festive-whip">' + icon("whip") + '</span>';
  };
  const mount = season => {
    document.querySelectorAll("[data-solave-owned-decoration]").forEach(node => node.remove());
    document.querySelectorAll("[data-solave-season-accent]").forEach(node => delete node.dataset.solaveSeasonAccent);
    document.querySelectorAll("[data-solave-season-card]").forEach(node => delete node.dataset.solaveSeasonCard);
    root.dataset.solaveMotion = motion.matches ? "gentle" : "full";
    delete root.dataset.solaveSeason;
    delete root.dataset.solaveEffects;
    activeSeason = season;
    window.solaveSeasonTheme = season ? {introArt: seasonalIcons[season].introArt, introLabel: seasonalIcons[season].introLabel} : null;
    document.querySelectorAll("[data-solave-seasonal]").forEach(mark => {
      mark.hidden = !season;
      mark.innerHTML = season ? seasonalIcons[season].mark : "";
      if (season) mark.dataset.season = season;
      else delete mark.dataset.season;
    });
    if (!season || !document.body) return;
    root.dataset.solaveSeason = season;
    const main = document.querySelector("#MainContent") || document.querySelector("main");
    main?.querySelectorAll(":scope > .shopify-section").forEach(section => section.dataset.solaveSeasonAccent = season);
    main?.querySelectorAll(".sv-steps article, .sv-product, product-card").forEach(element => {
      element.dataset.solaveSeasonCard = season;
      element.appendChild(owned("span", element.matches(".sv-steps article") ? "sv-season-step-mark" : "sv-season-card-mark", seasonalIcons[season].card));
    });
    const hero = main?.querySelector(".sv-hero-art");
    if (hero && season === "halloween") {
      const feature = owned("span", "sv-season-hero-feature", seasonalIcons.halloween.hero);
      feature.dataset.season = season;
      hero.appendChild(feature);
      hero.appendChild(owned("span", "sv-season-hero-spider", lineDrawing(spiderDrawing, 1000, 813, "#80694f", "sv-halloween-hanging-spider")));
    } else if (hero) hero.appendChild(owned("div", "sv-festive-hero sv-festive-hero--" + season, heroDecorations(season)));
    const footer = document.querySelector(".sv-footer");
    if (footer) {
      footer.dataset.solaveSeasonAccent = season;
      if (season !== "halloween") footer.appendChild(owned("span", "sv-festive-footer-art", seasonalIcons[season].hero));
    }
    mountScene(season);
    const button = document.createElement("button");
    button.type = "button";
    button.className = "sv-festive-toggle";
    button.dataset.solaveOwnedDecoration = "";
    button.addEventListener("click", () => {
      paused = !paused;
      try { localStorage.setItem("solave-season-effects-paused", paused ? "1" : "0"); } catch {}
      syncPaused();
    });
    document.body.appendChild(button);
    syncPaused();
  };
  const refresh = () => {
    const season = currentSeason();
    if (season !== activeSeason) mount(season);
  };
  const ready = () => {
    mount(currentSeason());
    setInterval(refresh, 60000);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready, {once: true});
  else ready();
  document.addEventListener("visibilitychange", () => {
    root.toggleAttribute("data-solave-page-hidden", document.hidden);
    if (!document.hidden) refresh();
  });
  window.addEventListener("pageshow", refresh);
  document.addEventListener("shopify:section:load", () => mount(currentSeason()));
  motion.addEventListener("change", () => mount(currentSeason()));
  compact.addEventListener("change", () => mount(currentSeason()));
})();
